import { alpha, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  composerCard: {
    marginTop: theme.spacing(2),
    borderRadius: 20,
    overflow: 'hidden',
    border: `1px solid ${alpha('#6366f1', 0.12)}`,
    background:
      'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
    boxShadow: '0 16px 36px rgba(15, 23, 42, 0.06)',
  },
  composerHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    padding: theme.spacing(2, 2.25, 1.25),
  },
  composerIcon: {
    width: 42,
    height: 42,
    borderRadius: 14,
    display: 'grid',
    placeItems: 'center',
    color: '#2563eb',
    fontWeight: 700,
    fontSize: '0.9rem',
    background:
      'linear-gradient(135deg, rgba(37,99,235,0.14) 0%, rgba(99,102,241,0.12) 100%)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.72)',
  },
  composerHeaderText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.35),
  },
  composerTitle: {
    fontSize: '0.96rem',
    fontWeight: 700,
    color: '#0f172a',
  },
  composerHint: {
    fontSize: '0.78rem',
    color: '#64748b',
  },
  container: {
    margin: theme.spacing(0, 2.25),
    padding: theme.spacing(1.25),
    borderRadius: 16,
    border: '1px solid rgba(148, 163, 184, 0.14)',
    backgroundColor: 'rgba(255,255,255,0.9)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.78)',
  },
  composerFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 2.25, 2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  composerMeta: {
    fontSize: '0.76rem',
    color: '#64748b',
  },
  sendComment: {
    minWidth: 150,
    borderRadius: 12,
    padding: theme.spacing(1, 2),
    fontWeight: 700,
    textTransform: 'none',
    boxShadow: '0 12px 24px rgba(37, 99, 235, 0.18)',
  },
}));

export default useStyles;
